import {
  Typography,
  Box,
  Button,
  Dialog,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import superagent from "superagent";
import { apiUrl } from "../common/apiUrl";
import { resetDefaults } from "../resetPassword/ResetConstant";

const PasswordExpiredModal = ({
  setQueryAuth,
  modalHeader,
  modalContent,
  username,
}) => {
  const [busy, setBusy] = useState(false);
  const [resendMessage, setResendMessage] = useState("");
  const [resendError, setResendError] = useState("");

  const handleResend = async () => {
    if (!username) {
      setResendError("Username is required to resend the reset link.");
      return;
    }
    setBusy(true);
    setResendError("");
    setResendMessage("");
    try {
      await superagent.post(apiUrl("/auth/password/forgot")).send({
        username,
      });
      setResendMessage(
        "A new password reset link has been sent. Check your email, then return to login."
      );
    } catch (err) {
      setResendError(
        err?.response?.body?.message ||
          "Unable to resend reset link. Try Forgot password from the login page."
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" sx={{ pb: 2 }}>
          {modalHeader}
        </Typography>
        <Typography variant="body1">{modalContent}</Typography>
        {resendMessage && (
          <Typography color="success" sx={{ mt: 2 }}>
            {resendMessage}
          </Typography>
        )}
        {resendError && (
          <Typography color="error" sx={{ mt: 2 }}>
            {resendError}
          </Typography>
        )}
        <Box
          display="flex"
          justifyContent="flex-end"
          gap={1}
          mt={4}
          flexWrap="wrap"
        >
          <Button
            variant="outlined"
            color="primary"
            size="large"
            data-testid="resend-reset-link-button"
            disabled={busy || !username}
            onClick={handleResend}
          >
            {busy ? <CircularProgress size={22} /> : resetDefaults.resendButton}
          </Button>
          <Button
            variant="text"
            color="primary"
            size="large"
            data-testid="got-it-button"
            onClick={() => {
              setQueryAuth({});
              window.location.href = process.env.REACT_APP_FAB;
            }}
          >
            {resetDefaults.gotItButton}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PasswordExpiredModal;
